(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name core.factory:ViberService
   *
   * @description
   *
   */
  angular
    .module('core')
    .factory('ViberService', ViberService);

  function ViberService($http, $q, EndpointsService) {
    var ViberServiceBase = {};

    ViberServiceBase.checkActivation = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.authenticationAdmin_checkUserViberActivation)
          .then(function (data) {
            deferred.resolve(data.data);
          }).catch(function (msg, code) {
          deferred.reject(msg.data);
        });
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    ViberServiceBase.activate = function (params){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.authenticationAdmin, params)
          .then(function (data) {
            deferred.resolve(data.data);
          }).catch(function (msg, code) {
          deferred.reject(msg.data);
        });
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    ViberServiceBase.deactivate = function (id, params){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.authenticationAdmin_id.replace('{id}', id), params)
          .then(function (data) {
            deferred.resolve(data.data);
          }).catch(function (msg, code) {
          deferred.reject(msg.data);
        });
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    ViberServiceBase.resendActivation = function (id, params){
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.put(response.links.authenticationAdmin_id.replace('{id}', id), params)
          .then(function (data) {
            deferred.resolve(data.data);
          }).catch(function (msg, code) {
          deferred.reject(msg.data);
        });
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    ViberServiceBase.becomeFollower = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.authenticationAdmin_requestViberSms)
          .then(function (data) {
            deferred.resolve(data.data);
          }).catch(function (msg, code) {
          deferred.reject(msg.data);
        });
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    return ViberServiceBase;
  }
}());
